import React from "react";
import ReactApexChart from "react-apexcharts";

class HorizonatlBarChart extends React.Component {
  constructor(props) {
    super(props);

    // Initialize the state
    this.state = {
      series: [],
      options: {
        chart: {
          type: "bar",
          height: 350,
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 3000,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: true,
            distributed: false, // Changed to false for grouped bars
            barHeight: "50%",
          },
        },
        colors: ["#4C6EF5", "#37D67A", "#FF4D4D", "#FFA726"], // Colors for different series
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#000"],
            fontSize: "12px",
          },
          offsetX: 5,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              colors: "#666",
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#666",
              fontSize: "12px",
            },
          },
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "left",
        },
        grid: {
          borderColor: "#e0e0e0",
        },
        tooltip: {
          enabled: true,
          theme: "light",
        },
        fill: {
          type: "solid",
        },
        stroke: {
          show: false,
        },
      },
    };
  }

  componentDidMount() {
    this.updateChartData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.subscriptionStats !== this.props.subscriptionStats) {
      this.updateChartData();
    }
  }

  updateChartData = () => {
    const { subscriptionStats } = this.props;

    if (
      !subscriptionStats ||
      !subscriptionStats.categories ||
      !subscriptionStats.series
    ) {
      this.setState({
        series: [],
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: [],
          },
        },
      });
      return;
    }

    // Start with zero values for animation
    const initialSeries = subscriptionStats.series.map((series) => ({
      name: series.name,
      data: new Array(subscriptionStats.categories.length).fill(0),
    }));

    this.setState({
      series: initialSeries,
      options: {
        ...this.state.options,
        xaxis: {
          ...this.state.options.xaxis,
          categories: subscriptionStats.categories,
        },
      },
    });

    setTimeout(() => {
      this.setState({
        series: subscriptionStats.series,
      });
    }, 500);
  };

  render() {
    return (
      <div>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={350}
        />
      </div>
    );
  }
}

export default HorizonatlBarChart;
